<template>
    <div class="invite">
        <img :src="user.imageUrl || 'https://yuedust.yuedu.126.net/snail_st/static/images/share/account_avatar_big@2x.png'" alt="用户头像" class="avatar">
        <div class="info">
            <template v-if="totalReadTimes">我在网易蜗牛读书阅读了{{totalReadTimes}}，</template>复制我的邀请码「<span class="code">{{inviteCode}}</span>」领取1天蜗牛会员，全场书免费看！
            <div class="copy" id="copy" @click="copyClickHandler">复制邀请码领福利</div>
        </div>
    </div>
</template>
<script>
// import copy from 'clipboard-copy'
import ClipboardJS from 'clipboard';
import toast from '../../js/utils/toast.js'
import {openAppSnail} from  'nw-app-snail'
export default {
    name: 'userInvite',
    props: {
        uuid: {
            type: String,
            required: true
        },
        copyHandler: {
            type: Function
        }
    },
    data(){
        return {
            inviteCode: '',
            totalReadTimes: '',
            user: {}
        }
    },
    async created(){
        const response = await this.$http.get('/user/info.json', {
            params: {
                uuid: this.uuid
            }
        })
        if(response && response.body && response.body.code === 0){
            // console.log(response.body);
            const data = response.body;
            this.inviteCode = data.inviteCode;
            if(data.totalReadTimes > 10*3600){
                const hour = parseInt(data.totalReadTimes/3600);
                const minute = parseInt((data.totalReadTimes - hour*3600)/60);
                this.totalReadTimes = `${hour}小时${minute}分钟`;
            }
            this.user = data.user;
        }
    },
    mounted() {
        this.clipboard = new ClipboardJS('#copy', {
            text: () => {
                return this.inviteCode;
            }
        })
        this.clipboard.on('success', e => {
            e.clearSelection();
            toast('已成功复制兑换码');
            setTimeout(() => {
                openAppSnail({
                    path: 'webview',
                    query: {
                        inside: true,
                        url: `${location.origin}/invite?code=${this.inviteCode}`
                    }
                })
            }, 1000);
        });

        this.clipboard.on('error', () => {
          toast('复制失败，请自行手动复制');
          setTimeout(() => {
              openAppSnail({
                  path: 'webview',
                  query: {
                      inside: true,
                      url: `${location.origin}/invite?code=${this.inviteCode}`
                  }
              })
          }, 1000);
        });
    },
    methods: {
        copyClickHandler(){
            if(this.copyHandler){
                // 复制按钮的打点
                this.copyHandler();
            }
            
            // const result = copy(this.inviteCode);
            // if(result){
            //     toast('已成功复制兑换码');
            //     setTimeout(() => {
            //         openAppSnail({
            //             path: 'webview',
            //             query: {
            //                 inside: true,
            //                 url: `${location.origin}/invite?code=${this.inviteCode}`
            //             }
            //         })
            //     }, 1000);
            // }
        }
    }
}
</script>
<style lang="scss" scoped>
    .invite{
        padding: .63rem .5rem 1.83rem;
        background: url(../images/share_wap_bottom_bg@3x.png) center bottom no-repeat;
        background-size: 100% auto;
        .avatar{
            display: block;
            margin: 0 auto;
            width: 1.02rem;
            height: 1.02rem;
            border-radius: 1.02rem;
            box-shadow: 0 .12rem .24rem 0 rgba(0,0,0,0.10);
        }
        .info{
            margin-top: -0.51rem;
            background: #fafafa;
            border-radius: .06rem;
            padding: .94rem .58rem 0;
            font-size: .28rem;
            color: #545454;
            line-height: .56rem;
            text-align: left;
            font-weight: bold;
            letter-spacing: 1px;
            .code{
                color: #CE5959;
            }
            .copy{
                width: 4.6rem;
                height: 1rem;
                line-height: 1rem;
                border-radius: 1rem;
                margin: .5rem auto 0;
                text-align: center;
                color: #fff;
                background: #B89477;
                font-size: .3rem;
                box-shadow: 0 .12rem .54rem 0 rgba(136,95,63,0.22);
            }
        }
    }
</style>


